import { EventEmitter, Injectable } from '@angular/core';

@Injectable()
export class EventBusService {
  changeButtonCaptionEvent: EventEmitter<any> = new EventEmitter();
  triggerSection: EventEmitter<{ sectionKey: string, methodName?: string, data?: any }> = new EventEmitter();
  clearActiveStepEvent: EventEmitter<any> = new EventEmitter();
  nextStepButtonVisibilityEvent: EventEmitter<boolean> = new EventEmitter();
}
